import { setToken } from 'lib/services/auth'
import {
  IS_QUALTRICS_ENABLED,
  IS_RECARDING_PREFERENCE_SURVEY_ENABLED
} from 'lib/feature-flags'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useSessionStore } from 'store/session'
import { Aside } from './Aside'
import { Header } from './Header'
import { MainContent } from './MainContent'
import { Wrapper } from './Wrapper'

import { useIntercom } from 'react-use-intercom'

import { UpdateVersionAlert } from 'components/UpdateVersionAlert'
import CardsExpiringSoonAlert from 'pages/cards/components/ExpiringSoonAlert'
import QualtricsSnippet from 'components/QualtricsSnippet'
import { RecardingPreferenceSurvey } from 'components/corporate-surveys/RecardingPreferenceSurvey'
// import { AdminRedundancyAlert } from 'components/AdminRedundancyAlert'

interface Props {
  children: React.ReactNode
}

export const Layout = ({ children }: Props) => {
  const [isRecardingPreferenceSurveyOpen, setIsRecardingPreferenceSurveyOpen] =
    useState(true)

  const { data, status } = useSession()
  const { updateSession } = useSessionStore((store) => store)
  const { pathname } = useRouter()

  const { boot, update } = useIntercom()

  useEffect(() => {
    if (data?.user) {
      updateSession(data.user, status)

      const createdDate = data?.user?.created_at
        ? new Date(data.user.created_at).getTime()
        : data?.user.corporate?.data.createdDate

      const bootAuthParams = {
        email: data?.user.email,
        name: data?.user.name,
        customAttributes: {
          first_name: data?.user.name,
          created_at: Number(createdDate) / 1000
        },
        company: {
          companyId: String(data?.user.corporate?.document),
          name: data?.user.corporate?.name,
          plan: data?.user.corporate?.data.planType,
          customAttributes: {
            cnpj: data?.user.corporate?.document,
            id: data?.user.corporate?.document,
            flexible_enabled:
              data?.user.corporate?.data.flexibleEnabled ?? false,
            health_insurance_support:
              data?.user.corporate?.data.healthInsuranceSupport ?? false,
            name_on_card: data?.user.corporate?.data.nameOnCard
          }
        }
      }

      boot(bootAuthParams.email ? bootAuthParams : {})
    }

    if (data?.user?.token) {
      setToken(data.user.token)
    }
  }, [boot, data, status, updateSession])

  useEffect(() => {
    if (data?.user) update()
  }, [pathname, update, data?.user])

  return (
    <Wrapper>
      <Aside />
      <Header />

      <MainContent>
        {children}
        {/* <AdminRedundancyAlert /> */}
        <UpdateVersionAlert />
      </MainContent>
      <CardsExpiringSoonAlert />
      {IS_RECARDING_PREFERENCE_SURVEY_ENABLED && (
        <RecardingPreferenceSurvey
          isOpen={isRecardingPreferenceSurveyOpen}
          onClose={() => setIsRecardingPreferenceSurveyOpen(false)}
        />
      )}
      {IS_QUALTRICS_ENABLED && <QualtricsSnippet />}
    </Wrapper>
  )
}
